import type { Graph, TemplateDataobject } from "@lr-notitia/notitia-engineer/schemas";
import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";
import * as Metrics from "../metrics";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const templateDataobjects = (graph: Ref<Graph>) =>
	computed<TemplateDataobject[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "dataobject" && node.layer === "template"
			) as TemplateDataobject[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology || {} })
				.toLocaleLowerCase()
				.localeCompare(
					symbolsStore.term({ id: b.refersTo, terminology: b.terminology || {} }).toLocaleLowerCase()
				)
		);
	});

export function templateDataobject(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => {
			Metrics.recordAccess(id);
			return graph.value.nodes[id] as TemplateDataobject | undefined;
		},
	};
}
